import { cn } from '@/utils/cn'
import { focusRing, segmentedRest, segmentedSelected } from '@/components/ui/buttonStyles'
import { RATING_COLOR, RATING_LABEL } from './ratingColors'

interface RatingButtonsProps {
  label: string
  selected: number | null
  onRate: (rating: number) => void
}

/** Again / Hard / Good / Easy as a row of pressable pills, each keyed to its rating colour. */
export function RatingButtons({ label, selected, onRate }: RatingButtonsProps) {
  return (
    <div role="group" aria-label={label} className="grid grid-cols-4 gap-2">
      {[1, 2, 3, 4].map((rating) => (
        <button
          key={rating}
          type="button"
          aria-pressed={selected === rating}
          onClick={() => onRate(rating)}
          className={cn(
            'flex min-h-11 items-center justify-center gap-2 rounded-full px-3 font-mono text-xs uppercase tracking-widest transition-colors duration-200',
            selected === rating ? segmentedSelected : segmentedRest,
            focusRing,
          )}
        >
          <span aria-hidden className="h-2 w-2 shrink-0 rounded-full" style={{ background: RATING_COLOR[rating] }} />
          {RATING_LABEL[rating]}
        </button>
      ))}
    </div>
  )
}
